<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-grade`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M40 4a2 2 0 011.995 1.85L42 6v37a2 2 0 01-1.85 1.995L40 45H8a2 2 0 01-1.995-1.85L6 43V6a2 2 0 011.85-1.995L8 4h32zm-2 4H10v33h28V8zm-4 25a1 1 0 011 1v1.5a1 1 0 01-1 1H14a1 1 0 01-1-1V34a1 1 0 011-1h20zm0-7a1 1 0 011 1v1.5a1 1 0 01-1 1H14a1 1 0 01-1-1V27a1 1 0 011-1h20zM19.602 11c.576.117.576.117.916.598l4.398 9.998c.108.801.108.801-.513 1.32-.196.07-.196.07-.403.084h-1.514c-.57-.115-.57-.115-.91-.586l-.771-1.693H17.13l-.684 1.66c-.338.497-.338.497-.926.619H14c-.776-.224-.776-.224-1-1.001.014-.207.014-.207.084-.403l4.398-9.998c.34-.48.34-.48.916-.598h1.203zm-.598 4.693l-.894 2.383h1.788l-.894-2.383z"/></svg>
</template>
<script>

export default {
  name: 'IconGrade',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
